/**
 * Journey id of a launch URL: `journeyId`, else the `journey_id` claim of the
 * PQ token (`journeyToken` or legacy `journey_token`). Decodes without
 * verifying, exactly as the edge and `parseAppParams` do. Shared with the
 * service worker, so: no imports.
 */
export const journeyIdFromUrl = (url: string): string | undefined => {
  let params: URLSearchParams

  try {
    params = new URL(url, 'http://offline.local').searchParams
  } catch {
    return undefined
  }

  const direct = params.get('journeyId')

  if (direct) return direct

  const token = params.get('journeyToken') ?? params.get('journey_token')

  if (!token) return undefined

  try {
    const payload = token.split('.')[1] ?? ''
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const claims: unknown = JSON.parse(json)
    const id = (claims as { journey_id?: unknown })?.journey_id

    return typeof id === 'string' ? id : undefined
  } catch {
    return undefined
  }
}
